<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="my-dialog-template template-product-dialog"
    width="1000px"
    top="30px"
    @close="reload()"
    :close-on-click-modal="false"
    append-to-body
  >
    <!-- 自定义弹窗标题：左侧主标题，右侧橙色提示文案 -->
    <template slot="title">
      <div class="dialog-custom-title">
        <span class="title-text">模板产品</span>
        <span class="title-tip">部分产品需要签署产品协议才能分配给下级团队业务员</span>
      </div>
    </template>
    <div class="content">
      <el-form :inline="true" class="my-form-template addProductForm">
        <el-form-item label="产品名称" prop="productName">
          <el-input type="text" v-model="searchParams.productName" placeholder="请输入产品名称" clearable @clear="clearInput"></el-input>
        </el-form-item>
        <!-- 产品类型筛选：1正常产品、2协议产品 -->
        <el-form-item label="产品类型" prop="needProductAgreement">
          <el-select v-model="searchParams.needProductAgreement" placeholder="请选择类型" clearable>
            <el-option label="正常产品" value="0"></el-option>
            <el-option label="协议产品" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" class="cxbt" @click="search()">查询</el-button>
          <el-button type="primary" class="cxbt" @click="$refs.addProductRef.open(templateId, allProductIds, '')">新增产品</el-button>
        </el-form-item>
      </el-form>
      <div class="tableContent">
        <div class="tools" v-if="nav.length > 0">
          <el-tabs class="template-tab" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="items.name" :name="items.themeId" v-for="items in nav" :key="items.themeId"></el-tab-pane>
          </el-tabs>
        </div>
        <el-table :data="tableData" stripe border class="list-table" style="width: 100%" v-loading="listLoading" tooltip-effect="dark">
          <el-table-column label="序号" type="index" width="80"></el-table-column>
          <el-table-column prop="name" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="needProductAgreement" label="产品类型" min-width="100">
            <template slot-scope="scope">
              <div class="tag2 blue" v-if="scope.row.needProductAgreement == 1">协议产品</div>
              <div class="tag2 green" v-else>正常产品</div>
            </template>
          </el-table-column>
          <el-table-column prop="lowPrice" :sort-method="sortByDate" sortable label="基础价格" min-width="100" show-overflow-tooltip=""></el-table-column>
          <el-table-column width="100" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination class="page" @size-change="pageNum=1;pageSize=$event;getList()" :pager-count="5" :current-page.sync='pageNum' :page-size.sync="pageSize" background layout="total, sizes, prev, pager, next, jumper" @current-change="getList()" :page-sizes="[10, 20, 50, 100]"  :total="total">
        </el-pagination> -->
        <div class="dialog-footer">
          <el-button type="warning" plain @click="visible = false">取消</el-button>
          <el-button type="warning" class="bgBtn" @click="save" :loading="btnLoading">确定</el-button>
        </div>
      </div>
    </div>
    <addProduct
      ref="addProductRef"
      @reload="
        pageNum == 1;
        getList();
        countProductByType();
      "
    ></addProduct>
  </el-dialog>
</template>
<script>
//当前实例组件
import addProduct from './addProduct.vue'
import { pageTool } from '@/api/mixins'
export default {
  mixins: [pageTool],
  data: () => ({
    visible: false,
    activeName: '0',
    nav: [],
    templateId: '', // 模板id
    btnLoading: false,
    allProductIds: [], // 全部产品id数组
    searchParams: {
      productName: '',
    }
  }),
  components: { addProduct },
  methods: {
    open(id) {
      // 暂时删除的产品列表
      this.$store.commit('SET_REMOVEDPRODUCT', [])
      this.searchParams = {}
      this.btnLoading = false
      this.visible = true
      if (id) {
        this.templateId = id
        this.countProductByType()
        this.initListAjax('/master/productTemplate/queryProductList')
      }
    },
    clearInput() {
      this.activeName = '0'
      this.searchAjax();
      this.countProductByType()
    },
    countProductByType() {
      this.$http({
        url: '/master/productTemplate/queryProductTheme',
        type: 'put',
        params: {
          templateId: this.templateId,
          productName: this.searchParams.productName,
        },
      }).then((data) => {
        this.nav = data.data
      })
    },
    // 设置自定义参数
    setListParams(params) {
      params.pageSize = 99999999
      params.templateId = this.templateId
      params.themeId = this.activeName == 0 ? '' : this.activeName
    },
    handleClick(val, event) {
      this.pageNum = 1
      this.searchAjax()
    },
    search() {
      this.activeName = '0'
      this.searchAjax()
      this.countProductByType()
    },
    save() {
      // 保存前，过滤掉已删除的产品
      this.allProductIds = this.allProductIds.filter(res => {
        return !this.$store.getters.removedProduct.some(item => res == item.id)
      })
      if (this.allProductIds.length > 0) {
        this.btnLoading = true
        this.$http({
          url: '/master/productTemplate/saveTemplateProduct',
          type: 'PUT',
          params: {
            templateId: this.templateId,
            productIds: this.allProductIds
          }
        }).then(res => {
          this.btnLoading = false
          if (res.httpCode == 200) {
            this.$message.success('保存成功')
            this.visible = false
            this.btnLoading = false
          }
        }).catch(e => {
          this.btnLoading = false
        })
      } else {
        this.$message.warning('请至少选择一款产品')
      }
    },
    //请求回调
    listCallback(res) {
      // 全部的产品Id
      this.allProductIds = res.allProductIds
      // 过滤当前列表已删除产品
      this.tableData = res.data.filter(item => {
        return !this.$store.getters.removedProduct.some(ele => ele.id === item.id)
      })
    },
    // 关闭弹窗刷新列表页
    reload() {
      this.$emit('reload')
    },
    //排序问题解决
    sortByDate(obj1, obj2) {
      let val1 = obj1.lowPrice
      let val2 = obj2.lowPrice
      return val1 - val2
    },
    del(item) {
      this.tableData.map((res, index) => {
        if (res.id == item.id) {
          let deleteItem = this.tableData.splice(index, 1)
          // 获取已删除的产品
          this.$store.commit('SET_REMOVEDPRODUCT', [...deleteItem, ...this.$store.getters.removedProduct])
        }
      })
    },
  },
  mounted() { },
}
</script>
<style lang="scss" scoped>
.template-product-dialog {
  /* 自定义标题：左侧主标题左对齐，右侧橙色提示文案 */
  .dialog-custom-title {
    display: flex;
    align-items: center;
    padding-right: 30px; /* 预留关闭按钮空间，避免与右上角关闭图标重叠 */
    .title-text {
      font-size: 20px;
      font-weight: 600;
      text-align: left;
    }
    .title-tip {
      font-size: 13px;
      font-weight: 400;
      color: #ff9700;
      margin-left: 20px;
    }
  }
  .content {
    .tableContent {
      margin-top: 8px;
      .tools {
        position: relative;
        line-height: 40px;
        height: 40px;
        margin-bottom: 20px;
        .total-num {
          position: absolute;
          right: 0;
          top: 10px;
          font-size: 14px;
          line-height: 20px;
          color: #888888;
          .n-color {
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: #fd9201;
          }
        }
      }
      .nav {
        margin-bottom: 10px;
        span {
          font-size: 16px;
          margin-right: 55px;
          cursor: pointer;
          margin-bottom: 5px;
          display: inline-block;
        }
        .active {
          border-bottom: 2px solid #ff9700;
          padding-bottom: 3px;
          cursor: pointer;
        }
      }
    }
  }

  .dialog-footer {
    margin-top: 30px;
  }
}
.list-table {
  margin-bottom: 32px;
  .cell {
    line-height: 25px;
  }
  ::v-deep {
    .el-table__row {
      height: 50px;
    }
    .el-table__body-wrapper {
      max-height: 550px;
      overflow-y: scroll;
    }
  }
}
</style>
